import React, { useEffect } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import { ColumnResizer } from '../styles';

const NAMESPACES = ['DYNAMIC_TABLE_OPERATIONS'];

const MoveableColumn = (props) => {
  const { uuid, tableUUID, tableRef, scaling, columnIndex, columnWidth, canMove, selected, groupHeaderHeight,
   onRearrange, onSingleClick, onDoubleClick } = props;
  const { t } = useTranslation(NAMESPACES);

  const tableHeight = tableRef.current?.getBoundingClientRect()?.height / scaling;

  const [ { isColumnDragging }, drag, preview ] = useDrag({
    item: {
      uuid,
      itemUUID: tableUUID,
      columnWidth,
      columnIndex,
      type: "column",
    },
    canDrag: () => canMove,
    begin: () => ({
      uuid,
      columnWidth,
      columnIndex,
      type: "column",
    }),
    collect: monitor => ({
      isColumnDragging: !!monitor.isDragging()
    })
  });

  const [{ isOver, isDragging }, drop] = useDrop({
    accept: ['column'],
    canDrop: () => selected,
    drop: (item, monitor) => {
      onRearrange(item.columnIndex, columnIndex);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isDragging: monitor.canDrop(),
      dragItem: monitor.getItem()
    })
  });

  const [{ isOverLeft }, leftDrop] = useDrop({
    accept: ['column'],
    canDrop: () => selected,
    drop: (item, monitor) => {
      onRearrange(item.columnIndex, columnIndex - 1);
    },
    collect: (monitor) => ({
      isOverLeft: monitor.isOver()
    })
  });

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  return (
/*    <Tooltip
      title={t(DYNAMIC_TABLE_OPERATIONS.MOVE_COLUMN.key, DYNAMIC_TABLE_OPERATIONS.MOVE_COLUMN.value)}
    >*/
      <ColumnResizer
        ref={drag}
        id={`t-column-${tableUUID}-${columnIndex}`}
        style={{ display: 'flex', cursor: canMove ? isColumnDragging ? 'grabbing' : 'grab' : "pointer", ...props.customStyle }}
        left={props.left}
        leftStart={props.leftStart}
        top={groupHeaderHeight ? groupHeaderHeight : 0}
        height={groupHeaderHeight ? `calc(100% - ${groupHeaderHeight}px)` : '100%'}
        selected={canMove}
        onClick={onSingleClick}
        onDoubleClick={onDoubleClick}
      >
        {props.children}
        {isDragging && (
        <>
        <div ref={leftDrop} style={{
           // position: "fixed",
           position: 'absolute',
           // top: columnBoundingClient?.top,
           top: 0,
           // left: columnBoundingClient?.left,
           left: 0,
           // height: '100%',
           height: tableHeight,
           width: '50%',
           // width: header.headerContent.style.width / 2,
           opacity: 0.5,
           borderLeft: isOverLeft ? '5px solid #00c4cc' : 'none'
        }} />
        <div ref={drop} style={{
          // position: "fixed",
          position: 'absolute',
          // top: columnBoundingClient?.top,
          top: 0,
          right: 0,
          // left: columnBoundingClient?.left + header.headerContent.style.width / 2,
          // height: '100%',
          height: tableHeight,
          width: '50%',
          // width: header.headerContent.style.width / 2,
          opacity: 0.5,
          borderRight: isOver ? '5px solid #00c4cc' : 'none'
        }} />
        </>)}
      </ColumnResizer>
/*    </Tooltip>*/
  )
}

export default MoveableColumn;